
import React from "react";
import { useSearchParams } from "@rivtn/noseur";
import { i18nManager } from "../i18n";
import MatchRow from "./common/MatchRow";
import PageHead from "./common/PageHead";
import Pagination from "./common/Pagination";
import FilterChips from "./common/FilterChips";
import { Utils } from "../../../../utils";
import styles from "../assets/style.module.css";
import { ApiResponseData, BaseService, ITeamWebsite, ITournamentEditionMatch, OmneHostService, SanitizedResponse } from "../../../../services";

export interface ScheduleProps {
    publicId: string;
    website: ITeamWebsite;
}

function Schedule({ website, publicId }: ScheduleProps) {

    const labels = i18nManager.Labels.schedule;
    const omnehostService = OmneHostService.getInstance();
    const [matches, setMatches] = React.useState<ApiResponseData<ITournamentEditionMatch>>();
    const { page, setPage, status, setStatus } = useSearchParams({ defaultInit: window.location.search, params: { page: 1, status: "" } });

    React.useEffect(fetchInformation, [omnehostService, page, status]);

    return (<>
        <PageHead kicker={labels.kicker} title={labels.title} subtitle={labels.desc} />
        <section className={styles["section-page"]}>
            <div className={styles["container"]}>
                <FilterChips value={`${status}`} onChange={setStatus} options={[["", labels.all], ["UPCOMING", labels.upcoming], ["ONGOING", labels.live], ["ENDED", labels.past]]} />
                {(!!matches?.content)
                    ? (matches.content.length > 0
                        ? (<div className={styles["match-list"]}>
                            {matches.content.map((t) => (<MatchRow key={t.external_id} match={t} website={website} publicId={publicId} />))}
                        </div>)
                        : Utils.emptyState())
                    : Utils.loadingState()}
                <Pagination page={parseInt(`${page}`)} rowsPerPage={matches?.size} totalRecords={matches?.total_elements} onPageChange={setPage} />
            </div>
        </section>
    </>);

    function fetchInformation() {
        setMatches({});
        omnehostService.queryTeamSchedule(website.team.public_id, {
            page,
            size: 20,
            status__eq: status,
            sort: ["start_date,ASC", "status,ASC"],
        }).then(({ apiResponse }: SanitizedResponse<ITournamentEditionMatch>) => {
            setMatches(apiResponse.data!);
        }).catch(BaseService.reportError);
    }
}

export default Schedule;
